import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const SamplesProduct = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-1083">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-1084">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1085">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-1086">
            Samples
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-1087">
            Product Samples
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1088">
            Feel the fabric, check the print quality, and review the
            construction before committing to a large order.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-1089">
          <p data-id="element-1090">
            We want you to be completely confident in the quality of our custom
            uniforms. Product samples allow you to evaluate our materials,
            stitching, and printing techniques firsthand.
          </p>
          <h3 data-id="element-1091">Types of Product Samples</h3>
          <ul data-id="element-1092">
            <li data-id="element-1093">
              <strong data-id="element-1094">Stock Samples:</strong> We can send pre-made samples from
              previous production runs to demonstrate fabric quality and print
              vibrancy. These ship quickly.
            </li>
            <li data-id="element-1095">
              <strong data-id="element-1096">Custom Prototypes:</strong> For large orders, we can
              produce a single custom prototype featuring your specific design
              and logos. This requires standard production time and a prototype
              fee.
            </li>
          </ul>
          <p data-id="element-1097">
            Please note that custom prototypes are highly recommended for
            complex designs or large-scale organizational orders to ensure all
            details meet your expectations.
          </p>

          <div className="mt-10 text-center not-prose" data-id="element-1098">
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-4 px-8 rounded-sm transition-colors text-base shadow-lg" data-id="element-1099">
              Request Product Samples
              <ArrowRight className="w-5 h-5" data-id="element-1100" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};